var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        name: "fade",
        mode: "out-in",
        duration: { enter: 700, leave: 100 }
      }
    },
    [
      _c(
        "div",
        { staticClass: "product-single-container page-container" },
        [
          _c(
            "button",
            {
              staticClass: "back-to-outfit",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$router.go(-1)
                }
              }
            },
            [
              _c("div", { staticClass: "wtw-container" }, [
                _c("span", { staticClass: "stay-black" }, [_vm._v("Back")])
              ])
            ]
          ),
          _vm._v(" "),
          _c("slide-show-zoom", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showZoomModal,
                expression: "showZoomModal"
              }
            ],
            ref: "zoom",
            attrs: {
              images: _vm.zoomImages,
              product: true,
              index: _vm.zoomIndex
            },
            on: {
              "close-modal": function($event) {
                _vm.showZoomModal = false
              }
            }
          }),
          _vm._v(" "),
          _vm.currentProduct &&
          _vm.dataLoaded &&
          !_vm.cartLoading &&
          !_vm.shareLoading
            ? _c("product-single", {
                key: "1",
                attrs: {
                  currentProduct: _vm.currentProduct,
                  outfit: _vm.currentOutfit,
                  slideShowImages: _vm.slideShowImages,
                  imageClicked: _vm.openImageZoom,
                  imageChanged: function() {},
                  outfitImageClicked: function(productId) {
                    return _vm.changeCurrentProduct(
                      _vm.currentOutfit,
                      productId
                    )
                  },
                  productChanged: function(product) {
                    return _vm.changeProduct(_vm.currentOutfit, product)
                  },
                  hideCard: false
                },
                on: { "change-product": _vm.productChanged }
              })
            : _c("div", { key: "2" }, [_c("loader")], 1)
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9906e376", { render: render, staticRenderFns: staticRenderFns })
  }
}